<template>
    <div class="integral">
        <div class="flex__around search-box">
            <div class="flex align-center search__item">
                <span class="fs_28 c_b3 jcicon jcicon-sousuo1">&nbsp;</span>
                <input class="fs_28" type="text" placeholder="请输入关键字搜索" v-model="keyword" @keyup.13="linkList">
            </div>
        </div>
        <div class="swiper-box">
            <swiper :options="swiperOption">
                <swiper-slide v-for="(item,index) in renders.carousel" :key="index"><img :src="item.image"></swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!-- nav -->
        <div class="flex__between nav-box">
            <div class="nav__item" v-link="'/Integral/Detailed'">
                <img src="@/assets/images/integral.png" alt="">
                <div class="flex__null__between nav__item__info">
                    <span class="fs_32 c_integral fw_600 lh_40">{{renders.integral_my}}</span>
                    <span class="fs_24 c_integral">可用积分</span>
                </div>
            </div>
            <div class="nav__item" v-link="'/Integral/Record'">
                <img src="@/assets/images/exchange.png" alt="">
                <div class="flex__null__between nav__item__info">
                    <span class="fs_32 c_396395 fw_600 lh_40">兑换记录</span>
                    <span class="fs_24 c_396395">去查看</span>
                </div>
            </div>
        </div>
        <!-- 滑动nav -->
        <div class="category-box">
            <swiper :options="swiperOptions">
                <swiper-slide class="flex wrap" v-for="(item,index) in renders.category" :key="index">
                    <div class="flex__between align-center column category__item" v-for="(item1,index1) in item" :key="index1" v-link="index1?'/Integral/List/'+item1.id:'/Coupon/Give'">
                        <img :src="item1.cover_img" alt="">
                        <span class="fs_14 c_4d">{{item1.name}}</span>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!-- 商品列表 -->
        <div class="row-box">
            <div class="flex row__item" v-for="(item,index) in list" :key="index" v-link="'/Integral/Detail/'+item.id">
                <img :src="item.cover_img" alt="">
                <div class="flex__null__around row__info">
                    <span class="fs_30 c_1a lh_40 ellipsis_two">{{item.name}}</span>
                    <div class="mt_10 lh_40">
                        <span class="fs_36 c_main" v-if="item.integral">{{item.integral}}<span class="fs_24">积分</span></span>
                        <span class="fs_24 c_main" v-if="item.integral&&item.money!='0.00'">+</span>
                        <span class="fs_28 c_main" v-if="item.money!='0.00'">{{item.money}}<span class="fs_24">元</span></span>
                    </div>
                    <span class="fs_24 c_80">已兑&nbsp;{{item.sales}}</span>
                </div>
            </div>
        </div>
        <jc-list :url="'/Integral/getIndexList'" :loads="loads" @load='getList'></jc-list>
    </div>
</template>
<script>
export default {
    name:'Integral',
    data(){
        return {
            keyword:'',
            renders:{},
            list:[],
            loads:{page:1},
            swiperOption: {
                initialSlide :1,
                loop : true,
                autoplay: 3000,
                autoplayDisableOnInteraction:false,
                pagination: '.swiper-pagination',
            },
            swiperOptions: {
                autoplay: false,
                pagination: '.swiper-pagination'
            }
        }
    },
    methods:{
        getList (data) { 
            this.list=data;
        },
        // 离交跳转到列表页
        linkList(){
            if(this.keyword){
                this.$store.commit('setIntegral',this.keyword);
                this.$router.push('/Integral/List/0');
            }
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Integral/getIndexData',{
            user_id: localStorage.user_id
        }).then(
            res=>{
                this.renders=res.data.data;
            }
        )
    }
}
</script>

<style scoped>
.swiper-box{
    padding: 10px 30px;
    background: #fff;
}
.swiper-box img{
    width:690px;
    height:300px;
    border-radius: 10px;
}
/* nav菜单 */
.nav-box{
    padding: 20px 30px 0;
    background: #fff;
}
.nav__item{
    position: relative;
    width: 330px;
    height: 120px;
    border-radius: 10px;
}
.nav__item img{
    position: absolute;
    top: 0;
    left: 0;
    width: 330px;
    height: 120px;
    border-radius: 10px; 
}
.nav__item__info{
    position: absolute;
    top: 0;
    left: 0;
    width: 330px;
    height: 120px;
    padding: 20px 30px;
}
.c_396395{
    color: #396395;
}
/* swiper菜单 */
.category-box{
    background: #fff;
}
.category-box .swiper-container{
    padding-bottom: 70px;
}
.category-box .swiper-slide{
    padding: 10px 0 0;
}
.category-box img{
    width: 90px;
    height: 90px;
    border-radius: 50%;
}
.category__item{
    width: 150px;
    height: 140px;
    margin-top: 30px;
}
.category__item:nth-child(5n+1){
    margin-left: 0;
} 
/* 商品 */
.row-box{
    overflow: hidden;
    padding: 0 30px 30px;
    margin-top: 15px;
    background: #fff;
}
.row__item{
    margin-top: 30px;
}
.row__item img{
    width: 250px;
    height: 250px;
    border-radius: 10px;
}
.row__info{
    width: 410px;
    margin-left: 30px;
}
</style>




// WEBPACK FOOTER //
// src/pages/integral/Index.vue